<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <md-button class="md-primary md-sm" v-on:click.native="logout"
        >Logout</md-button
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      name: this.$auth.user.name || this.$auth.user.preferred_username
    };
  },
  methods: {
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  }
};
</script>
